import React, { useState, useRef, useEffect } from 'react';
import {
    MDBAccordion,
    MDBAccordionItem,
    MDBSideNav,
    MDBSideNavMenu,
    MDBSideNavItem,
    MDBSideNavLink,
    MDBSideNavCollapse,
    MDBBtn,
    MDBIcon,
    MDBModalFooter
} from 'mdb-react-ui-kit';
import { Link, useNavigate } from "react-router-dom";
import { browserName, browserVersion, isMobile } from "react-device-detect";
// import GymLogo from '../../components/images/Easy-MembrLogo.png'
import GymLogo from "../../components/images/easybook.png";
import { CancelationPolicy, ClassBookings, ClassDashboard, Classes, ClassLogout, ClassSchedules, ClassTrainers } from '../../components/images/ClassAssets';
import { getGBussinessInfo, getStaffProfile, logEvent } from '../../services/classApiServices.js';
import BusinessForm from '../BusinessForm';
import Popup from '../../components/Popup';
import businessImg from "../../components/images/Business.svg";
// import transcImg from "../images/Transactions.svg";
import transcImg from "../../components/images/Transactions.svg";
import settingsImg from "../../components/images/Settings.svg";
import { getmultigyms, getPricingPlansById, getStaffByGym } from '../../services/apiServices';
// import event from "./images/activity-svgrepo-com.svg";
import event from "../../../src/components/images/activity-svgrepo-com.svg"
import { useAccess } from '../../context/AccessContext';


export default function SideNavClass({ children, activeTab, modeOpen, setModeOpen, mode, setMode }) {
    const sidenavContent = useRef(null);
    const [container, setContainer] = useState();
    const [showBusinessPop, setShowBusinessPop] = useState(false);
    const bussName = (localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymname) : "");
    const navigate = useNavigate();
    const { roleAccess, classRoleAccess, loading } = useAccess();


    useEffect(() => {
        setContainer(sidenavContent.current);
    }, []);
    let userInfoInSession = localStorage.getItem("loggedUserInfo") ? true : false;
    const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : false;
    const [noPlanpopup, setnoPlanpopup] = useState(false);
    let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
    const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
    const isAdmin = loggedUserInfo?.role !== "staff";
    const [mdata, setMdata] = useState("")
    const [selectedGym, setSelectedGym] = useState("");

    const handleChangePlan = () => {
        navigate(`/billingmanagementplans`)
    };
    let expiryPlanpopup = false;
    useEffect(() => {
        let getLoggedInGymInfo = async () => {
            try {
                if (localStorage.getItem("loggedUserInfo") === null) {
                    navigate("/login");
                    return;
                } else {

                    if (
                        JSON.parse(localStorage.getItem("loggedUserInfo")).isemailverifed ===
                        "1"
                    ) {
                        const response = await getGBussinessInfo(gymid);
                        // console.log('555555555555555555555555');

                        if (!response || response === "false") {
                            return;
                        }
                        // console.log('5555555555555333355555555555');

                        const recinfo = await response.json();
                        // console.log(recinfo);
                        // console.log('55555555555555555555555599999');
                        // setBussName(recinfo.businessName)


                        if (
                            !recinfo.businessName ||
                            !recinfo.firstName ||
                            !recinfo.lastName ||
                            !recinfo.contactNumber ||
                            !recinfo.address) {
                            setShowBusinessPop(true);
                        }

                    }
                }
            } catch (e) { }
            //return { name: userInfo.gym, loc: userInfo.gymloc };
        };

        getLoggedInGymInfo();

    });



    useEffect(() => {
        const fetchMData = async () => {
            try {
                const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
                if (!loggedUser) return;

                const payload = {
                    gymid: loggedUser.gymid,
                };

                if (!(loggedUser.rolevalues && loggedUser.rolevalues.includes(1))) {
                    payload.staffId = loggedUser._id;
                }

                const response = await getmultigyms(payload);
                if (!response || !response.ok) return;

                const data = await response.json();

                if (!Array.isArray(data)) {
                    setMdata([]);
                    return;
                }

                // Move current gym to top
                const selectedGymIndex = data.findIndex(
                    (business) => business._id === loggedUser.gymid
                );

                if (selectedGymIndex > -1) {
                    const selectedGym = data.splice(selectedGymIndex, 1)[0];
                    data.unshift(selectedGym);
                }

                setMdata(data);

            } catch (error) {
                console.error("Failed to fetch data:", error);
            }
        };



        if (localStorage.getItem("loggedUserInfo")) {
            fetchMData();
        }
    }, [gymid]);


    const handleSelectChange = async (event) => {
        const selectedId = event.target.value;

        const selectedBusiness = mdata?.find(
            (business) => business._id === selectedId
        );
        if (!selectedBusiness) return;

        const storedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
        if (!storedUser) return;

        const isOwner = storedUser.rolevalues?.some(
            (r) => Number(r) === 1
        );

        let updatedUser = {
            ...storedUser,
            gymid: selectedBusiness._id,
            gymname:
                selectedBusiness?.displayname && selectedBusiness?.displayname !== ""
                    ? selectedBusiness.displayname
                    : selectedBusiness.businessName,
            gymlogoUrl: selectedBusiness.logourl,
        };

        try {
            // Only staff calls API
            if (!isOwner) {
                const updates = {
                    gymid: selectedBusiness._id,
                    email: storedUser.email,
                    number: storedUser.number,
                };

                try {
                    const response = await getStaffByGym(updates);

                    if (response && response.ok) {
                        const staffData = await response.json();

                        if (staffData?.data?._id) {
                            //  Update staff ID if found
                            updatedUser._id = staffData.data._id;
                        }
                    }

                    // If API fails or staff not found → do nothing
                    // Gym switch still allowed

                } catch (apiError) {
                    console.log("Staff API error, switching without changing _id");
                }
            }

            // Always save updated gym info
            localStorage.setItem("loggedUserInfo", JSON.stringify(updatedUser));

            // Log event (unchanged logic)
            let ip = localStorage.getItem("ipaddress");
            let browserinfo = browserName + "-" + browserVersion + ".0.0";
            let Eventtype = "gym-switch";
            let username1 = storedUser?.email || "";

            let flag = `Switched to Gym (${selectedBusiness.businessName})`;

            logEvent(
                {
                    Eventtype,
                    username1,
                    ip,
                    flag,
                    browserinfo,
                    gymid: selectedBusiness._id,
                },
                selectedBusiness._id
            );

            window.location.reload();

        } catch (error) {
            console.error("Gym switch failed:", error);
        }
    };




    async function handleClick() {
        try {


            let ip = localStorage.getItem("ipaddress");
            let browserinfo = browserName + "-" + browserVersion + ".0.0";
            let flag = "Class Booking logout successful";
            let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
            let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
            let Eventtype = username1;

            await logEvent({
                Eventtype, username1, ip, flag, browserinfo, gymid, isclass: true
            }, gymid);


            sessionStorage.clear();
            localStorage.removeItem("transaction_filter");
            localStorage.removeItem("loggedUserInfo");
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            localStorage.removeItem("ipaddress");
            window.location.href = "/login";
            localStorage.removeItem("planInfo");
            localStorage.removeItem("frontEndEnvData");
            //this.context.router.transitionTo('/login');
            //return;
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        const getPricingPlansBYGymid = async () => {
            const response = await getPricingPlansById(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response) {
                return
            }
            if (response === "false") {
                return
            }
            const recinfo = await response.json();
            if (recinfo && recinfo.feature) {
                localStorage.setItem("planInfo", JSON.stringify(recinfo));
                setnoPlanpopup(false);
            } else {
                localStorage.removeItem("planInfo");
                setnoPlanpopup(true);
            }
        }
        if (localStorage.getItem("loggedUserInfo")) {
            getPricingPlansBYGymid();
        } else {
            localStorage.removeItem('planInfo');
        }
    }, [localStorage.getItem("planInfo"), localStorage.getItem("loggedUserInfo")]);
    useEffect(() => {
        if (!localStorage.getItem("planInfo")) {
            setTimeout(() => {
                setnoPlanpopup(true);
            }, 6000);
        } else {
            setnoPlanpopup(false);
        }
    }, [localStorage.getItem("planInfo")]);
    const handleRenewPlan = async () => {
        if (plansInfo != null) {
            let planid = plansInfo?._id;
            navigate(`/billingmanagementplans?id=${planid}&value=${1}`);
        } else {
            navigate(`/billingmanagementplans`)
        }
    };
    let baldays = (plansInfo != null && plansInfo.planUsage.baldays) || 0;
    const days = Math.floor(baldays);
    const hours = Math.round((baldays - days) * 24);
    if (plansInfo != null && plansInfo?.planUsage?.status === 0) {
        expiryPlanpopup = true;
    }


    const handleMemberDashboardClick = async () => {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const gymid = userInfo.gymid || "";
        const username1 = userInfo.email || "user";
        const fullName =
            userInfo.name || `${userInfo.fname || ""} ${userInfo.lname || ""}`.trim() || "User";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;
        const flag = `Member Management module accessed by (${fullName})`;

        try {
            await logEvent(
                {
                    Eventtype: username1,
                    username1,
                    ip,
                    flag,
                    browserinfo,
                    gymid,
                    isclass: true
                },
                gymid
            );
        } catch (err) {
            console.error("Logging failed:", err);
        }

        // navigate("/classdashboard");
    };
    const userRole = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).role : "";


    return (
        <>
            <MDBSideNav
                mode={mode}
                open={modeOpen}
                contentRef={container}
                absolute
                getOpenState={(e) => setModeOpen(e)}
                style={{ width: '320px' }}
            >
                <MDBSideNavMenu>
                    {isMobile &&
                        <div className='classesSideNavClose' onClick={() => setModeOpen(false)}>
                            <MDBIcon fas icon='times' size='lg' />
                        </div>
                    }

                    <div className="user-info px-3">
                        <Link to="/classdashboard">
                            <div className="w-100 d-flex align-items-center justify-content-start ps-3">
                                <img src={GymLogo} className='logoImg' />
                            </div>
                        </Link>

                        <h5 className="mx-2 title">
                            {bussName ? bussName : ""}

                        </h5>
                        {userInfoInSession &&
                            <div className='d-flex flex-wrap mb-3'>
                                {JSON.parse(localStorage.getItem("loggedUserInfo")).name ? <p className="expiry mx-1 mb-0 chip bg-secondary bg-opacity-50">
                                    {JSON.parse(localStorage.getItem("loggedUserInfo")).name}
                                </p> : null}
                                {JSON.parse(localStorage.getItem("loggedUserInfo")).role ?
                                    <p className="expiry mx-1 mb-0 title chip bg-info bg-opacity-50">
                                        {JSON.parse(localStorage.getItem("loggedUserInfo")).role}
                                    </p> : null}
                                {(plansInfo != null) ? <>
                                    <p className="expiry mx-1 mb-0 chip bg-success bg-opacity-50">{plansInfo.name}
                                        <button
                                            className="button-link fw-600 px-1 text-primary fs-10px"
                                            onClick={isAdmin ? handleChangePlan : undefined}
                                            style={{ pointerEvents: !isAdmin ? "none" : "auto" }}
                                        >
                                            Change Plan
                                        </button>
                                    </p>
                                </>
                                    : <></>}
                            </div>}

                        {plansInfo != null && !(plansInfo?.planUsage?.lifetimefree) ? (
                            (baldays <= 0) ?
                                <button onClick={isAdmin ? handleRenewPlan : undefined} title='Renew plan'
                                    className="btn btn-danger my-1 w-100" style={{ pointerEvents: !isAdmin ? "none" : "auto" }}>
                                    Plan Expired/Renew
                                </button> : ((baldays <= 10) ?
                                    <button onClick={isAdmin ? handleRenewPlan : undefined} title='Renew plan'
                                        className="btn btn-warning my-1 w-100" style={{ pointerEvents: !isAdmin ? "none" : "auto" }}>
                                        Expires in {days == 0 ? <>{hours} hour(s)</> : <>{days} day(s)</>}
                                    </button>
                                    :
                                    <button onClick={isAdmin ? handleRenewPlan : undefined} title='Renew plan'
                                        className="btn btn-primary my-1 w-100" style={{ pointerEvents: !isAdmin ? "none" : "auto" }}>
                                        Expires in {days} day(s)
                                    </button>
                                )
                        ) : ""
                        }
                    </div>



                    <div style={{ height: "40px" }}>
                        {Array.isArray(mdata) && mdata.length > 1 && (
                            <div className='select-wrapper' >
                                <div className='form-outline'>
                                    <select
                                        style={{ lineHeight: "1.2", marginBottom: "0.5rem" }}
                                        id="business-dropdown form-control-sm"
                                        className="form-select "
                                        onChange={handleSelectChange}
                                        defaultValue={selectedGym}
                                        value={selectedGym}
                                    >
                                        {mdata.map((business) => (
                                            <option key={business._id} value={business._id}>
                                                {business?.displayname && business?.displayname != "" ? business?.displayname : business.businessName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                    </div>



                    <div className='d-flex flex-column justify-content-between '>
                        <div className="gym-bar-block">
                            {classRoleAccess?.classdashboard?.access && <Link
                                id="hs-bp"
                                to="/classdashboard"
                                //   onClick={(event) => handleLinkClick(event, '/dashboard')}
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "classdashboard" ? "active" : ""
                                    }`}
                            >
                                <img src={ClassDashboard} alt="Logo" />
                                Dashboard
                            </Link>}
                            {classRoleAccess?.businessinfo?.access &&
                                <> <Link
                                    id="hs-bp"
                                    to="/classesbusiness"
                                    //   onClick={(event) => handleLinkClick(event, '/dashboard')}
                                    className={`gym-bar-item gym-button gym-hover-white ${activeTab === "classesbusiness" ? "active" : ""
                                        }`}
                                >
                                    <img src={businessImg} alt="Logo" />
                                    BusinessInfo
                                </Link></>}

                            {classRoleAccess?.classes?.access && <Link
                                id="hs-bp"
                                to="/classes"
                                //   onClick={(event) => handleLinkClick(event, '/dashboard')}
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "Classes" ? "active" : ""
                                    }`}
                            >
                                <img src={Classes} alt="Logo" />
                                Classes
                            </Link>}

                            {classRoleAccess?.schedules?.access && <Link
                                id="hs-bp"
                                to="/classschedules"
                                //   onClick={(event) => handleLinkClick(event, '/dashboard')}
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "classschedules" ? "active" : ""
                                    }`}
                            >
                                <img src={ClassSchedules} alt="Logo" />
                                Schedules
                            </Link>}
                            {classRoleAccess?.classtransaction?.access && <Link
                                id="hs-bp"
                                to="/classtransaction"
                                //   onClick={(event) => handleLinkClick(event, '/dashboard')}
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "classtransaction" ? "active" : ""
                                    }`}
                            >
                                <img src={transcImg} alt="Logo" />
                                Class Transaction
                            </Link>}
                            {/* <Link
                                id="hs-bp"
                                to="/classesbooking"
                                //   onClick={(event) => handleLinkClick(event, '/dashboard')}
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "ClassesBooking" ? "active" : ""
                                    }`}
                            >
                                <img src={ClassBookings} alt="Logo" />
                                Bookings
                            </Link> */}

                            {classRoleAccess?.trainers?.access && <Link
                                id="hs-bp"
                                to="/classusers"
                                //   onClick={(event) => handleLinkClick(event, '/dashboard')}
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "ClassUsers" ? "active" : ""
                                    }`}
                            >
                                <img src={ClassTrainers} alt="Logo" />
                                Trainers
                            </Link>}



                            {classRoleAccess?.cancelationpolicy?.access && <Link
                                id="hs-bp"
                                to="/CancelationPolicy"
                                //   onClick={(event) => handleLinkClick(event, '/dashboard')}
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "CancelationPolicy" ? "active" : ""
                                    }`}
                            >
                                <img src={CancelationPolicy} alt="Logo" />
                                Cancelation Policy
                            </Link>}
                            {classRoleAccess?.classactivities?.access && <Link
                                id="hs-bp"
                                to="/classlogevent"
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "Classevent" ? "active" : ""}`}
                            >
                                <img src={event} alt="Logo" /> Activities
                            </Link>}
                            {roleAccess?.manageaccount?.access && <Link
                                to="/classsettings"
                                id="hs-bp"
                                // onClick={(event) => handleLinkClick(event, '/settingview')}
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "classsettings" ? "active" : ""
                                    }`}
                            >
                                <img src={settingsImg} alt="Logo" /> Manage Account
                            </Link>}
                            <div className={`subtab-link`}>
                                <MDBAccordion initialActive={1}>
                                    <MDBAccordionItem className='sub-tab subclasstb' collapseId={2} headerTitle={<><i class="fas fa-hand-holding-heart"></i>Modules</>}>
                                        <ul className='list-unstyled m-0'>
                                            <li className='sublist ps-3' onClick={handleMemberDashboardClick}> <Link to="/dashboard" className='ps-3'>EasyMembr</Link></li>
                                            {/* <li className='sublist' onClick={() => navigate("/login")}>Mebar Management</li> */}
                                        </ul>
                                    </MDBAccordionItem>
                                </MDBAccordion>
                            </div>
                            <Link
                                id="hs-bp"
                                to="/classusers"
                                onClick={handleClick}
                                //   onClick={(event) => handleLinkClick(event, '/dashboard')}
                                className={`gym-bar-item gym-button gym-hover-white ${activeTab === "Logout" ? "active" : ""
                                    }`}
                            >
                                <img src={ClassLogout} alt="Logo" />
                                Logout
                            </Link>
                        </div>
                    </div>
                </MDBSideNavMenu>
            </MDBSideNav >

            <div style={{ backgroundColor: "#dadada26", minHeight: "100vh" }}>
                {/* <div style={{ padding: '20px' }} className='text-center'>
                    <MDBBtn onClick={() => setModeOpen(!modeOpen)}>
                        <MDBIcon fas icon='bars' />
                    </MDBBtn>
                </div> */}

                <div ref={sidenavContent} className='my-5'>

                    {children}

                </div>
            </div>
            {
                showBusinessPop && (
                    <>
                        <Popup
                            title="Please update your Business Informaion to continue"
                            ptype="modal-lg"
                            content={
                                <>
                                    <BusinessForm />
                                </>
                            }
                            handleClose={() => setShowBusinessPop(false)}

                        />
                    </>
                )
            }
            {
                noPlanpopup && (<>
                    <Popup
                        title="Plan Subscription"
                        ptype="modal-md"
                        style=""
                        content={
                            <>
                                Seems you haven't subscribed yet! Subscribe for more features.
                                <MDBModalFooter className="pe-2 pb-2">
                                    <MDBBtn color='secondary' onClick={() => handleClick()}>Cancel</MDBBtn>
                                    <MDBBtn onClick={isAdmin ? handleChangePlan : undefined}
                                        style={{ pointerEvents: !isAdmin ? "none" : "auto" }}>
                                        Subscribe</MDBBtn>
                                </MDBModalFooter>
                            </>
                        }
                        handleClose={() => handleClick()}
                    />
                </>
                )
            }
            {
                expiryPlanpopup && (
                    <>
                        <Popup
                            title="Renew Subscription"
                            ptype="modal-md"
                            style=""
                            content={
                                <>
                                    <div className='pb-2'>
                                        Oops! Your subscription Plan has expired.
                                        {userInfoInSession && (JSON.parse(localStorage.getItem("loggedUserInfo")).role == "staff")
                                            ? "" : " Please renew for uninterrupted service."}
                                    </div>
                                    <MDBModalFooter className="pe-2 pb-2">
                                        <MDBBtn color='secondary' onClick={() => handleClick()}>Cancel</MDBBtn>
                                        <MDBBtn onClick={handleRenewPlan} style={{ pointerEvents: !isAdmin ? "none" : "auto" }}>Renew</MDBBtn>
                                    </MDBModalFooter>
                                </>
                            }
                            handleClose={() => handleClick()}
                        />
                    </>
                )
            }
        </>
    );
}